import { FilterTypes } from '@/models/Filters';
import type {
  Deals_Bool_Exp,
  GetDealsQuery,
  GetDealsQueryVariables,
} from '@/utilities/__generated__/graphql';
import { GetDealsDocument } from '@/utilities/__generated__/graphql';
import { createApolloClient } from '@/utilities/createApolloClient';
import { sortDeals } from '@/utilities/functions';

//TODO: this needs better error handling
export async function loadDeals({
  limit,
  dealCondition,
}: {
  date: string;
  limit?: number;
  dealCondition?: Record<FilterTypes, Deals_Bool_Exp>;
}) {
  const client = createApolloClient();

  // Filters to apply. Change this to add or remove filters to be applied
  const filterTypes = [FilterTypes.Collection];
  const dealConditions: Deals_Bool_Exp = {
    _and: [...filterTypes.map((type) => (dealCondition ?? {})[type] ?? {})],
  };
  const { data } = await client.query<GetDealsQuery, GetDealsQueryVariables>({
    query: GetDealsDocument,
    variables: {
      limit,
      dealsWhere: dealConditions,
    },
  });
  const sortedDeals = sortDeals(data.Deals);

  return {
    deals: sortedDeals,
  };
}
